import React, { useEffect, useState } from "react";
import _ from 'underscore';
import { Form, Input, DatePicker, TimePicker, Select, Button, message } from 'antd';
import { Confirm, Understood } from '../Notification/index.js';
import dayjs from 'dayjs'
import dayTypesArray from './utils/day-type-requests/dayTypes.js';
import statusArray from './utils/day-type-requests/status.js';
import AuthLogic from '../../AuthLogic/index.js';
import { fromPairs } from "lodash";

const { Option } = Select;

const datePickerFormat = { format: 'YYYY-MM-DD' };
const timePickerFormat = { format: 'h:mm a' };

const DayTypeRequestsCalendarGeneralForm = ({ contextMenuKey, dayTypeRequestDetails, dayTypesAll, dayTypesDayRule, ...props }) => {

  const [form] = Form.useForm();
  const optionsStatus = Object.assign([], statusArray.map((item) => ({ label: item.name, value: item.value })))

  const optionsDayTypes = (dayTypesDayRule && dayTypesDayRule.length > 0) ?
    (
      dayTypesDayRule.map((dayTypeOption) => {
        return { label: dayTypeOption.dayTypeName, value: dayTypeOption.dayTypeId, approvalNeeded: dayTypeOption.approvalNeeded.toString() }
        //return <Option key={`${index}dayType`} value={dayTypeOption.dayTypeId} approvalneeded={dayTypeOption.approvalNeeded.toString()} >{dayTypeOption.dayTypeName}</Option>
      })
    )
    :
    (
      dayTypesArray.map((dayTypeOption) => {
        return { label: dayTypeOption.name, value: dayTypeOption.id, approvalNeeded: 'false' }
        //return <Option key={`${index}dayType`} value={dayTypeOption.name} >{dayTypeOption.name}</Option>
      })
    )

  const [approvalNeeded, setApprovalNeeded] = useState(true);

  const { getFieldsError, getFieldsValue } = form;

  const [selectedDates, setSelectedDates] = useState([]);
  const [isMultiDates, setIsMultiDates] = useState(false);



  const sortDates = (a, b) => {
    if (a.start.toISOString() < b.start.toISOString()) {
      return -1
    }
    if (a.start.toISOString() < b.start.toISOString()) {
      return 1
    }
    return 0;
  }

  useEffect(() => { // set form values

    let copySelected = [...dayTypeRequestDetails.selectedDates || []];
    let sorted = [];
    if (copySelected.length > 0) {
      sorted = copySelected.sort(sortDates);
    }

    form.setFieldsValue({
      dayType: dayTypeRequestDetails.dayTypeId ? dayTypeRequestDetails.dayTypeId : undefined,
      fromDate: dayTypeRequestDetails.fromDate ? dayjs(dayTypeRequestDetails.fromDate) : null,
      toDate: dayTypeRequestDetails.toDate ? dayjs(dayTypeRequestDetails.toDate) : null,
      fromTime: dayTypeRequestDetails.fromTime ? dayjs(dayTypeRequestDetails.fromTime) : null,
      toTime: dayTypeRequestDetails.toTime ? dayjs(dayTypeRequestDetails.toTime) : null,
      status: dayTypeRequestDetails.status ? dayTypeRequestDetails.status : 'U',
      myComment: dayTypeRequestDetails.myComment,
      statusComment: dayTypeRequestDetails.statusComment,
      datesSelected: sorted.map((event) => { return dayjs(event.start).format("YYYY-MM-DD") + " to " + dayjs(event.end).format("YYYY-MM-DD") + "\n" }).join('')
    });


    setSelectedDates(() => sorted);
    setIsMultiDates(() => dayTypeRequestDetails.isMultiDates);

  }, [dayTypeRequestDetails, dayTypesDayRule]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 2,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };
  const validateDayType = (form) => {
    const dayType = form.getFieldValue('dayType');
    if (!dayType) {
      let dayTypeErrors = [];
      dayTypeErrors.push('Please input day type!')

      form.setFields([{
        name: 'dayType',
        value: dayType,
        errors: dayTypeErrors
      }]);
    }
  }

  const validateDates = (form) => {

    let fromDate = form.getFieldValue('fromDate') ? dayjs(form.getFieldValue('fromDate')).startOf('day') : null;
    let toDate = form.getFieldValue('toDate') ? dayjs(form.getFieldValue('toDate')).startOf('day') : null;

    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push('Please input start date!');
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push('Start date cannot occur after end date!');
    }
    form.setFields([{
      name: 'fromDate',
      value: fromDate,
      errors: fromDateErrors
    }]);


    if (toDate == null) {
      toDate = fromDate;
    }

    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push('Please input end date!');
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push('End date cannot occur before start date!');
    }
    form.setFields([{
      name: 'toDate',
      value: toDate,
      errors: toDateErrors
    }]);

    if (fromDate == null) {
      fromDate = toDate
      form.setFields([{
        name: 'fromDate',
        value: fromDate,
        errors: fromDate ? [] : fromDateErrors
      }]);

    }

  }

  const validateTime = (form) => {
    const fromTime = form.getFieldValue('fromTime') ? dayjs(form.getFieldValue('fromTime')) : null;
    const toTime = form.getFieldValue('toTime') ? dayjs(form.getFieldValue('toTime')) : null;
    let fromTimeErrors = [];
    if (toTime && fromTime && toTime.isBefore(fromTime)) {
      fromTimeErrors.push('Start time cannot occur after end time!');
    }
    if (!fromTime && toTime) {
      fromTimeErrors.push('Please choose a start time if you have an end time!');
    }

    form.setFields([{
      name: 'fromTime',
      errors: fromTimeErrors
    }]);

    let toTimeErrors = [];
    if (fromTime && toTime && fromTime.isAfter(toTime)) {
      toTimeErrors.push('End time cannot occur before start time!');
    }
    if (!toTime && fromTime) {
      toTimeErrors.push('Please choose an end time if you have a start time!');
    }

    form.setFields([{
      name: 'toTime',
      errors: toTimeErrors
    }]);
  }

  const validateComments = (form) => {
    let statusComment = form.getFieldValue('statusComment') || '';
    let myComment = form.getFieldValue('myComment') || '';


    let statusCommentErrors = [];
    if (statusComment && statusComment.length > 250) {
      statusCommentErrors.push('Maximum length is 250 characters!')
      statusComment = statusComment.substring(0, 250)
    }

    form.setFields([{
      name: 'statusComment',
      value: statusCommentErrors ? statusComment : statusComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g, ''),
      errors: statusCommentErrors
    }]);


    let myCommentErrors = [];
    if (myComment && myComment.length > 250) {
      myCommentErrors.push('Maximum length is 250 characters!')
      myComment = myComment.substring(0, 250)
    }

    form.setFields([{
      name: 'myComment',
      value: myCommentErrors ? myComment : myComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g, ''),
      errors: myCommentErrors
    }]);

  }

  const validateForm = () => { // validates the whole form

    validateDayType(form);
    if (!isMultiDates) {
      validateDates(form);
      validateTime(form);
    }
    validateComments(form);
  }

  const validateHasHolidays = async (params) => {

    let dayTypeHasHolidays = await props.checkIfHasHolidaySchedule(params);

    return dayTypeHasHolidays;
  }

  const createWithValidation = async (formValues, hasHolidays) => {
    if (hasHolidays) {
      await continueCreate(formValues);
    } else {
      Confirm('key', { title: 'Validate Date', content: 'STORM was not able to validate if the selected date(s) are holiday(s). Do you want to continue?' }, async (key, value) => {
        if (value) {
          await continueCreate(formValues);
        }
      });
    }
  }

  const handleCreate = async () => {
    validateForm();
    
    const listErrors = form.getFieldsError()
    const hasErrors = listErrors.some(({ errors }) => errors.length > 0);
    if (hasErrors) {
      invalidForm();
      return;
    } ;

    let formValues = getFieldsValue()
    if (formValues.status.value) {
      formValues.status = formValues.status.value;
    }
    let dateRangeInfo = { tourCounter: 0, jeCounter: 0, tourApproved: 0, jeApproved: 0 }
    let hasHolidays = true;
    let foundDayType;
    var rules = await props.getDayTypesByDayRule();
    var all = dayTypesAll;

    if (rules && rules.length && rules.length > 0) {
      foundDayType = rules.find(dayType => dayType.dayTypeId === formValues.dayType);
    } else {
      foundDayType = all.find(dayType => dayType.dayTypeId === formValues.dayType);
    }
    if (isMultiDates) {
      for (let event of selectedDates) {
        let params = { dayType: formValues.dayType, fromDate: dayjs(event.start), toDate: dayjs(event.end), status: formValues.status }
        let info = await props.checkIfTourInDateRange(params);
        if (info) {
          dateRangeInfo.tourCounter += info.tourCounter;
          dateRangeInfo.jeCounter += info.jeCounter;
          dateRangeInfo.tourApproved += info.tourApproved;
          dateRangeInfo.jeApproved += info.jeApproved;

        }
        let has = await validateHasHolidays(params)
        if (!has) hasHolidays = false;
      }
    } else {
      dateRangeInfo = await props.checkIfTourInDateRange(formValues);
      hasHolidays = await validateHasHolidays(formValues)
    }

    if (!(dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0))) {
      await createWithValidation(formValues, hasHolidays);
      return;
    }

    if (dateRangeInfo.tourApproved > 0) {
      const message = 'There are approved tours in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });
      return;
    }
    if (dateRangeInfo.jeApproved > 0) {
      const message = 'There are tours with approved assigments in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });
      return;
    }

    if (foundDayType.allowTourScheduling) {
      await props.createDayTypeRequest(formValues);
      return;
    }

    if (formValues.status != "A") {
      await createWithValidation(formValues, hasHolidays);
      return;
    }

    if (props.user.securityLevels.allowDeletingTour == 2) {/*No*/
      const message = 'There are tours/assignments in the date range chosen.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });

    } else {
      const message = 'There are tours/assignments in the date range chosen.\nDo you want to proceed with this request and delete the tours/assignments?'
      Confirm('key', { title: 'Tours in date range', content: message }, async (key, value) => {
        if (value) {
          await createWithValidation(formValues, hasHolidays);
        }
      });

    }

  }


  const continueCreate = async (formValues) => {
    if (isMultiDates) {
      await props.createMultipleDayTypeRequests(formValues);
    } else {
      await props.createDayTypeRequest(formValues);
    }
  }

  const handleUpdate = async () => {
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue()

      let dateRangeInfo = await props.checkIfTourInDateRange(formValues);
      if (dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0) && formValues.status === "A") {
        const message = 'There are tours/assignments in the date range chosen. Do you want to proceed with this request and delete the tours/assignments?'
        Confirm('key', { title: 'Tours in date range', content: message }, (key, value) => {
          if (value) {
            console.log('Success! Received values of form: ', formValues)
            props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
          }
        });
      } else {
        console.log('Success! Received values of form: ', formValues);
        props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }
  
  const handleKeyPress = (e) => {
        e.preventDefault();
        let inputField = e.target;
        const start = inputField.selectionStart;
        const end = inputField.selectionEnd;
        const currentValue = inputField.value;
        const sanitizedText = e.data.replace(/[^a-zA-Z0-9,:;\-.!@?#%|\/$()&\s\n]/g, "");
        const newValue= currentValue.slice(0, start) + sanitizedText + currentValue.slice(end);
        switch (e.currentTarget.id) {
      case "myComment":
        form.setFieldsValue({ myComment: newValue });
        break;
      case "statusComment":
        form.setFieldsValue({ statusComment: newValue });
        break;
    }
        
    };

  const handleDelete = () => {
    if (dayTypeRequestDetails.dayTypeRequestId) {
      props.deleteDayTypeRequest(dayTypeRequestDetails.dayTypeRequestId);
    } else {
      message.config({
        top: 150,
        duration: 5,
        maxCount: 5,
      });
      message.error('Could not perfom delete on this request');
    }
  }

  const formItemDisabledOnEdit = () => {
    //review when update enabled
    //contextMenuKey ? !AuthLogic.addDayTypeRequest(props.user) : !AuthLogic.editDayTypeRequest(props.user)

    return !contextMenuKey;
  }

  const formCommentReadOnly = () => {
    return props.user.securityLevels.remark != 3/*Edit*/
  }
  const formCommentStatusReadOnly = () => {
    return props.user.securityLevels.statusRemark != 3
  }

  const formCommentVisible = () => {
    return props.user.securityLevels.remark != 1/*None*/
  }
  const formCommentStatusVisible = () => {
    return props.user.securityLevels.statusRemark != 1
  }

  const handleApprovalNeeded = (e, t) => {
    if (t) {

      let approval = (t.approvalNeeded === 'true' || t.approvalNeeded === true);
      setApprovalNeeded(approval);
      if (!approval) {
        form.setFieldsValue({ status: { value: "A" } });
      } else {
        form.setFieldsValue({ status: { value: "U" } });
      }
    }
    props.handleDayTypeChange(e, validateForm);
  }

  const controlButtonDisabled = {
    backgroundColor: '#f5f5f5',
    color: 'rgb(143, 143, 143)',
    cursor: 'not-allowed',
    opacity: 1,
    resize: "none",
  }
  const controlButtonEnabled = {
    resize: "none"
  }

  return (

    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
      <Form.Item
        label="Day Type"
        style={{ marginBottom: 5 }}
        name="dayType"
        rules={[{
          required: true, message: 'Please input a Day Type!',
        }]}>

        <Select
          onChange={(e, t) => { handleApprovalNeeded(e, t); }
          }
          allowClear={true}
          style={{ width: 250, zIndex: 2000 }}
          disabled={(formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType) ? true : false}
          options={optionsDayTypes}


        >

        </Select>

      </Form.Item>
      {isMultiDates &&
        <Form.Item label="Dates Selected" style={{ marginBottom: 5 }} name="datesSelected">
          <Input.TextArea
            style={{ resize: "none" }}
            size={'large'}
            readOnly={true}
            rows={4}

          />

        </Form.Item>}
      {!isMultiDates &&
        <Form.Item label="From Date" style={{ marginBottom: 5 }} name="fromDate"
          rules={[
            {
              required: true,
              message: 'Please input start date!'
            },
          ]}>
          <DatePicker
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleFromDateChange(e, validateForm)}
            allowClear={true}
            placeholder={'Select date'}
            format={datePickerFormat}
            
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
            disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          />
        </Form.Item>}
      {!isMultiDates &&
        <Form.Item label="To Date" style={{ marginBottom: 5 }} name="toDate"
          rules={[
            {
              required: true,
              message: 'Please input end date!'
            },
          ]}>
          <DatePicker
            //showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleToDateChange(e, validateForm)}
            allowClear={true}
            placeholder={'Select date'}
            format={datePickerFormat}
            
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
            disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          />
        </Form.Item>}

      {!isMultiDates &&
        <Form.Item label="From Time" style={{ marginBottom: 5 }} name="fromTime">
          <TimePicker
            onChange={(e) => props.handleFromTimeChange(e, validateForm)}
            allowClear={false}
            format={timePickerFormat}
            style={{ marginLeft: 5, marginRight: 5 }}
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
            disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
            use12Hours={true}
            minuteStep={15}
            showNow={false}
          />
        </Form.Item>}
      {!isMultiDates &&
        <Form.Item label="To Time" style={{ marginBottom: 5 }} name="toTime">
          <TimePicker
            onChange={(e) => props.handleToTimeChange(e, validateForm)}
            allowClear={false}
            format={timePickerFormat}
            style={{ marginLeft: 5, marginRight: 5 }}
            styles={{
              popup: {
                root: {
                  zIndex: 2000
                }
              }
            }}
            disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
            use12Hours={true}
            minuteStep={15}
            showNow={false}
          />
        </Form.Item>}

      {AuthLogic.viewStatus(props.user) &&
        <Form.Item label="Status" style={{ marginBottom: 5 }} name="status"
          rules={[{
            required: true, message: 'Please input a status!',
          }]}>
          <Select
            onChange={(e) => props.handleStatusChange(e, validateForm)}
            style={{ width: 250, zIndex: 2000 }}
            {...(((!approvalNeeded || !AuthLogic.editStatus(props.user)) || formItemDisabledOnEdit()) ? { disabled: true } : {})}
            options={optionsStatus}
          >

          </Select>
        </Form.Item>
      }

      {formCommentVisible() &&
        <Form.Item label="My Comment" style={{ marginBottom: 5 }} name="myComment">
          <Input.TextArea
            onChange={(e) => props.handleMyCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit() || formCommentReadOnly()) ? '' : 'Enter text here.'}
            readOnly={formItemDisabledOnEdit() || formCommentReadOnly()}
            style={(formItemDisabledOnEdit() || formCommentReadOnly()) ? controlButtonDisabled : controlButtonEnabled}
            rows={4}
            onBeforeInput={handleKeyPress}

          />
        </Form.Item>
      }

      {formCommentStatusVisible() &&
        <Form.Item label="Status Comment" style={{ marginBottom: 5 }} name="statusComment">
          <Input.TextArea
            onChange={(e) => props.handleStatusCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit() || formCommentStatusReadOnly()) ? '' : 'Enter text here.'}
            readOnly={formItemDisabledOnEdit() || formCommentStatusReadOnly()}
            style={(formItemDisabledOnEdit() || formCommentStatusReadOnly()) ? controlButtonDisabled : controlButtonEnabled}
            rows={4}
            onBeforeInput={handleKeyPress}

          />
        </Form.Item>
      }

      {contextMenuKey
        ?
        <React.Fragment>
          {AuthLogic.addDayTypeRequest(props.user) && (
            <Form.Item
              style={{ marginTop: 20 }}
            >
              <Button type="primary" size={'large'} onClick={handleCreate}>
                Create
              </Button>
            </Form.Item>
          )}
        </React.Fragment>
        :
        <React.Fragment>
          <Form.Item
            style={{ marginTop: 20 }}
          >
            {/* {AuthLogic.editDayTypeRequest(props.user) && (
              <Button type="primary" size={'large'} onClick={handleUpdate}>
                Update
              </Button>
            )} */}

            {/* {AuthLogic.removeDayTypeRequest(props.user) && dayTypeRequestDetails.status !== 'A' && (
              <Button type="danger" size={'large'} onClick={handleDelete}>
                Delete
              </Button>
            )} */}
          </Form.Item>
        </React.Fragment>
      }
    </Form>

  );
}

export default DayTypeRequestsCalendarGeneralForm;
